export const LoaderInline = () => {
	return <>
		<span className="loading-dots">
			<span></span>
			<span></span>
			<span></span>
		</span>
	</>
}
